const {zone_time} = require("./schedule-report");
module.exports = {
    props: ['user', 'teams'],

};
